import { t } from 'i18next'
import { Dropdown } from 'primereact/dropdown'
import { useEffect, useState } from 'react'
import { API_APPRENTICESHIP_MODULE_PLANS } from '../../../../../constants'
import { ApprenticeshipModulePlan } from '../../../../../model/apprenticeshipModule.model'
import { RequestMethod } from '../../../../../model/enums/enums'
import { handleRequest } from '../../../../../services/api/base/handleRequest'

export const ModulePlanDropdown = (props: {
  selected: ApprenticeshipModulePlan | undefined
  setSelected: (modulePlan: ApprenticeshipModulePlan) => void
}) => {
  const [modulePlans, setModulePlans] = useState<ApprenticeshipModulePlan[]>()

  useEffect(() => {
    const loadModulePlans = async () => {
      const result = await handleRequest<ApprenticeshipModulePlan[]>(
        API_APPRENTICESHIP_MODULE_PLANS(),
        RequestMethod.GET
      )
      if (result.data && !result.error) {
        setModulePlans(result.data.filter((mp) => mp.is_active === 1))
      } else {
        console.warn('[ModulePlanDropdown] Failed to load module plans.')
      }
    }
    loadModulePlans()
  }, [])

  const itemTemplate = (modulePlan: ApprenticeshipModulePlan) => {
    const modulesCount = modulePlan.apprenticeship_modules?.length
    let modulesCountText = ''
    if (modulesCount) {
      modulesCountText = `(${modulesCount} ${t<string>(
        'grade_module.education_plan.modules_count'
      )})`
    }
    return (
      <>
        <b>{modulePlan.description}</b>{' '}
        <span className={'small-text secondary-text'}>{modulesCountText}</span>
      </>
    )
  }

  return (
    <Dropdown
      id={'modulePlanDropdown'}
      value={props.selected}
      placeholder={t<string>('core.select')}
      optionLabel={'description'}
      itemTemplate={itemTemplate}
      onChange={(e) => props.setSelected(e.target.value)}
      filter
      className={'w-full'}
      filterBy={'description'}
      options={modulePlans}
    />
  )
}